module.exports = __webpack_public_path__ + "img/tob_18.10178397.svg";